import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import { AisHistoryMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type AisHistoryMapItemProps = { data: AisHistoryMapItem };

export const AisHistoryPopup = ({ data }: AisHistoryMapItemProps) => {
  const { date } = data;

  const formatDate = useDateFormatter();
  const formattedDate = formatDate({ date: Date.parse(date) });

  return <GenericPopup subheader={formattedDate} hideCloseIcon />;
};
